import { createActions } from 'redux-actions';

export default createActions(
  {
    RESET: () => ({}),
    INIT: (robotId) => ({ robotId }),
    SET: (robotId, data) => ({ robotId, data }),
    REMOVE: (robotId) => ({ robotId }),
  },
  { prefix: 'ROBOT_PARAMS' }
);
